import { render, staticRenderFns } from "./FieldsGroup.vue?vue&type=template&id=6fa5ed80&scoped=true&"
import script from "./FieldsGroup.vue?vue&type=script&lang=js&"
export * from "./FieldsGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa5ed80",
  null
  
)

export default component.exports